// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import { BASE_URL } from './utils/api';
import App from './App';

// Force absolute base for ANY axios call
axios.defaults.baseURL = BASE_URL.replace(/\/+$/, '');
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  const isAbs = /^https?:\/\//i.test(url);
  if (!isAbs) {
    config.url = `${axios.defaults.baseURL}/${url.replace(/^\/+/, '')}`;
  }
  return config;
});

const root = createRoot(document.getElementById('root'));
root.render(<App />);
